"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledButton = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _clsx = _interopRequireDefault(require("clsx"));

var _useTheme = _interopRequireDefault(require("../useTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: inline;\n  cursor: pointer;\n  padding: 7px 14px;\n  font-size: 14px;\n  font-family: 'Raleway', sans-serif;\n  color: #5b5b5b;\n  outline: none;\n  background-color: transparent;\n  border: none;\n\n  &.pui-button--variant-contained {\n    border: 1px solid ", ";\n    outline-color: ", ";\n    background-color: ", ";\n    color: #ffffff;\n\n    &:not(.pui-button--disabled):hover {\n      background-color: ", ";\n    }\n\n    &:not(.pui-button--disabled):focus {\n      box-shadow: 0px 0px 5px ", ";\n    }\n  }\n\n  &.pui-button--variant-outlined {\n    background: none;\n    border: 1px solid ", ";\n    outline-color: ", ";\n    color: ", ";\n\n    &:not(.pui-button--disabled):hover {\n      background-color: ", "20;\n    }\n\n    &:not(.pui-button--disabled):focus {\n      box-shadow: 0px 0px 5px ", ";\n    }\n  }\n\n  &.pui-button--variant-text {\n    background-color: transparent;\n    color: ", ";\n    outline-color: ", ";\n\n    &:hover {\n      color: ", ";\n    }\n\n    &:focus {\n      outline-color: ", ";\n    }\n  }\n\n  &.pui-button--variant-link {\n    color: ", ";\n    text-decoration: underline;\n    padding: 0px !important;\n    margin: 0px;\n\n    &:not(.pui-button--disabled):hover {\n      color: ", ";\n    }\n  }\n\n  &.pui-button--disabled {\n    opacity: 0.6;\n    cursor: default;\n  }\n\n  &.pui-button--size-small {\n    padding: 7px 14px;\n    font-size: 10px;\n  }\n\n  &.pui-button--size-medium {\n    padding: 7px 14px;\n    font-size: 14px;\n  }\n\n  &.pui-button--size-large {\n    padding: 7px 14px;\n    font-size: 18px;\n  }\n\n  &.pui-button--border-rounded {\n    border-radius: 15px 15px;\n  }\n\n  &.pui-button--border-squared {\n    border-radius: 3px 3px;\n  }\n\n  &.pui-button--with-margin {\n    margin: 0px 4px;\n  }\n\n  .pui-button__icon.pui-button__icon--dock-left {\n    margin-right: 4px;\n  }\n\n  .pui-button__icon.pui-button__icon--dock-right {\n    margin-left: 4px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledButton = _styledComponents["default"].button(_templateObject(), function (props) {
  return props.theme.palette[props.color]['500'];
}, function (props) {
  return props.theme.palette[props.color]['500'];
}, function (props) {
  return props.theme.palette[props.color]['500'];
}, function (props) {
  return props.theme.palette[props.color]['300'];
}, function (props) {
  return props.theme.palette[props.color]['300'];
}, function (props) {
  return props.theme.palette[props.color]['500'];
}, function (props) {
  return props.theme.palette[props.color]['500'];
}, function (props) {
  return props.theme.palette[props.color]['500'];
}, function (props) {
  return props.theme.palette[props.color]['500'];
}, function (props) {
  return props.theme.palette[props.color]['300'];
}, function (props) {
  return props.theme.palette[props.color]['700'];
}, function (props) {
  return props.theme.palette[props.color]['500'];
}, function (props) {
  return props.theme.palette[props.color]['800'];
}, function (props) {
  return props.theme.palette[props.color]['700'];
}, function (props) {
  return props.theme.palette['primary']['500'];
}, function (props) {
  return props.theme.palette['primary']['900'];
});
/**
 * Button component
 */


exports.StyledButton = StyledButton;

var Button = function Button(_ref) {
  var component = _ref.component,
      className = _ref.className,
      variant = _ref.variant,
      size = _ref.size,
      border = _ref.border,
      disabled = _ref.disabled,
      withMargin = _ref.withMargin,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["component", "className", "variant", "size", "border", "disabled", "withMargin", "children"]);

  props.theme = (0, _useTheme["default"])();

  if (component !== 'button') {
    props.as = component;
  }

  props.className = (0, _clsx["default"])(className, 'pui-button', {
    'pui-button--disabled': disabled,
    'pui-button--with-margin': withMargin
  }, "pui-button--variant-".concat(variant), "pui-button--border-".concat(border), "pui-button--size-".concat(size));
  return /*#__PURE__*/_react["default"].createElement(StyledButton, props, children);
};

Button.propTypes = {
  /**
   * Component type
   */
  component: _propTypes["default"].elementType,

  /**
   * Button color
   */
  color: _propTypes["default"].string,

  /**
   * Button size
   */
  size: _propTypes["default"].string,
  // PropTypes.string(['small', 'medium', 'large']),

  /**
   * Button style
   */
  variant: _propTypes["default"].string,
  // PropTypes.oneOf(['contained', 'outlined', 'text', 'link']),

  /**
   * Border style
   */
  border: _propTypes["default"].string,
  // PropTypes.oneOf(['rounded', 'squared']),
  disabled: _propTypes["default"].bool,
  withMargin: _propTypes["default"].bool
};
Button.defaultProps = {
  component: 'button',
  color: 'primary',
  size: 'medium',
  variant: 'contained',
  border: 'squared',
  disabled: false,
  withMargin: false
};
var _default = Button;
exports["default"] = _default;